import type {ValidContentEntrySlug} from "astro:content"

export const BREAKPOINTS = {
    xs: 420,
    sm: 640,
    md: 768,
    lg: 1024,
    xl: 1280,
}

export const GET_BREAKPOINTS_AS_PX = () => {

    type Breakpoint = keyof typeof BREAKPOINTS

    const breakpoints = {} as Record<Breakpoint, string>

    Object.entries(BREAKPOINTS).forEach(([key, val]) => breakpoints[key as Breakpoint] = val + 'px')

    return breakpoints

}

export const BRAND_NAME = 'DipSway'

export interface Social {
    label: string
    href: string
    icon: `i-${string}:${string}`
}

export const SOCIALS = {
    trustpilot: {
        label: 'Trustpilot',
        href: 'https://www.trustpilot.com/review/dipsway.com',
        icon: 'i-simple-icons:trustpilot'
    },
    producthunt: {
        label: "Producthunt",
        href: "https://www.producthunt.com/products/dipsway",
        icon: "i-ri:product-hunt-fill",
    },
    sourceforge: {
        label: "Sourceforge",
        href: "https://sourceforge.net/software/product/DipSway",
        icon: "i-bi:sourceforge",
    },
    telegram: {
        label: 'Telegram',
        href: 'https://t.me/+mMJ2A14bQrc1YzNk',
        icon: 'i-mingcute:telegram-fill'
    },
    calendly: {
        label: 'Calendly',
        href: 'https://calendly.com/luca-dipsway/30min',
        icon: 'i-bi:calendar-event',
    },
    linkedin: {
        label: "Linkedin",
        href: "https://www.linkedin.com/company/dipsway/",
        icon: "i-bi:linkedin",
    },
    instagram: {
        label: "Instagram",
        href: "https://www.instagram.com/dipsway.bot/",
        icon: "i-ri:instagram-line",
    },
    x: {
        label: "X",
        href: "https://x.com/dipsway_bot",
        icon: "i-bi:twitter-x",
    }
} satisfies Record<string, Social>

type FeaturedPost = ValidContentEntrySlug<'blog'>

export const FEATURED_POSTS: {
    [lang: string]: [FeaturedPost, FeaturedPost, FeaturedPost, FeaturedPost]
} = {
    "en": [
        "what-makes-a-good-trading-bot-to-be-good",
        "why-is-crypto-crashing-and-will-it-recover-in-the-near-future",
        "you-re-safe-with-dipsway",
        "how-to-optimize-your-ai-bot",
    ],
    "de": [
        "3commas-alternativen",
        "ai-krypto-bot-setup-status",
        "ai-trading-bots",
        "beste-altcoins-zum-handeln-2024-top-tipps-fuer-krypto-investoren",
    ],
    "es": [
        "abraza-el-poder-del-bot-de-ai-de-dipsway-para-el-comercio-exitoso-de-cripto",
        "altcoins-trading-es",
        "alternativas-a-3commas",
        "alternativas-a-bitsgap",
    ],
    "fil": [
        "bitcoin-converter-fil",
        "bitsgap-alternatibo",
        "bot-ng-pagsusuri-ng-sentimyento-sa-pangangalakal-ng-crypto",
        "bybit-bots-alternatibo",
    ],
    "fr": [
        "cryptohopper-alternatives-fr",
        "difference-entre-piece-et-jeton",
        "dipsway-et-bitget-sassocient-apprenez-a-connecter-bitget-gagnez-des-recompenses",
        "dipsway-nouvelle-plateforme",
    ],
    "it": [
        "come-collegare-chiavi-api-avanzate-coinbase",
        "come-collegare-chiavi-api-binance",
        "come-collegare-chiavi-api-bitmart",
        "come-collegare-chiavi-api-bybit",
    ],
    "ko": [
        "감정분석봇암호화폐거래",
        "너는-딥스웨이와-안전해",
        "단순화된-현물-계약-소개-트레이더-위한",
        "딥스웨이-뉴-플랫폼",
    ],
    "nl": [
        "hoe-coinbase-advanced-api-sleutels-te-verbinden",
        "hoe-kraken-legacy-api-sleutels-te-verbinden",
        "hoe-kucoin-api-sleutels-verbinden",
        "hoe-optimaliseer-je-ai-bot",
    ],
    "pt" : [
        "diferenca-entre-moeda-e-token",
        "dipsway-e-bitget-unem-se-aprenda-como-conectar-bitget-ganhe-recompensas",
        "dipsway-nova-plataforma",
        "dipsway-vs-coinrule-pt",
    ],
    "ru": [
        "budet-li-kripto-krakh",
        "bybit-bots-alternativy",
        "chto-luchshe-dlya-avtomaticheskoy-torgovli-kriptovalyutami-dipsway-ili-3commas",
        "chto-delaet-khoroshego-treynding-bota-khoroshim",
    ],
    "tr": [
        "binance-grid-botu-her-sey-hakkinda-bilmeniz-gerekenler",
        "bingx-dipsway-baglama",
        "bitcoin-donusturucu",
        "bitmart-api-anahtarlarini-baglama",
    ],
    "zh": [
        "为什么-dipsway-是-终极-平台-为-加密-交易者-顶级-选择-为-初学者-和-专业人士-一样",
        "为什么你需要ai在你的加密机器人",
        "为什么加密货币崩盘并且它会在不久的将来恢复吗",
        "什么使一个好的交易机器人变得优秀",
    ]
}

export type CurrencyName = 'eur' | 'usd'

export interface Currency {
    name: CurrencyName
    label: string
    icon: string
    sign: string
}

// only used in calculator at the moment, but selected currency should be available everywhere via local storage 
export const availableCurrencies: Record<CurrencyName, Currency> = {
    'usd': {
        name: 'usd',
        label: 'USD',
        icon: 'i-mdi:dollar',
        sign: '$'
    },
    'eur': {
        name: 'eur',
        label: 'EUR',
        icon: 'i-mdi:euro',
        sign: '€'
    }
}


// NOTE: if you modify this you also need to modify the one in the endpoint (?)

export type ConverterCurrencyItem = {
    name: string,
    long_name: string,
    label: string,
    icon: string,
    sign: string
}

export const converterCurrencies:Array<ConverterCurrencyItem> = [
    {
        name: 'usd',
        long_name: 'United States Dollar',
        label: 'USD',
        icon: 'i-mdi:currency-usd',
        sign: '$'
    },
    {
        name: 'eur',
        long_name: 'Euro',
        label: 'EUR',
        icon: 'i-mdi:currency-eur',
        sign: '€'
    },
    {
        name: 'gbp',
        long_name: 'British Pound Sterling',
        label: 'GBP',
        icon: 'i-mdi:currency-gbp',
        sign: '£'
    },
    {
        name: 'jpy',
        long_name: 'Japanese Yen',
        label: 'JPY',
        icon: 'i-mdi:currency-jpy',
        sign: '¥'
    },
    {
        name: 'cny',
        long_name: 'Chinese Yuan',
        label: 'CNY',
        icon: 'i-mdi:currency-cny',
        sign: '¥'
    },
    {
        name: 'aud',
        long_name: 'Australian Dollar',
        label: 'AUD',
        icon: 'i-mdi:currency-aud',
        sign: 'A$'
    },
    {
        name: 'cad',
        long_name: 'Canadian Dollar',
        label: 'CAD',
        icon: 'i-mdi:currency-cad',
        sign: 'C$'
    },
    {
        name: 'chf',
        long_name: 'Swiss Franc',
        label: 'CHF',
        icon: 'i-mdi:currency-chf',
        sign: 'Fr'
    },
    {
        name: 'inr',
        long_name: 'Indian Rupee',
        label: 'INR',
        icon: 'i-mdi:currency-inr',
        sign: '₹'
    },
    {
        name: 'krw',
        long_name: 'South Korean Won',
        label: 'KRW',
        icon: 'i-mdi:currency-krw',
        sign: '₩'
    },
    {
        name: 'brl',
        long_name: 'Brazilian Real',
        label: 'BRL',
        icon: 'i-mdi:currency-brl',
        sign: 'R$'
    },
    {
        name: 'rub',
        long_name: 'Russian Ruble',
        label: 'RUB',
        icon: 'i-mdi:currency-rub',
        sign: '₽'
    },
    {
        name: 'try',
        long_name: 'Turkish Lira',
        label: 'TRY',
        icon: 'i-mdi:currency-try',
        sign: '₺'
    },
    {
        name: 'bgn',
        long_name: 'Bulgarian Lev',
        label: 'BGN',
        icon: 'i-mdi:currency-bgn',
        sign: 'лв'
    },
    {
        name: 'czk',
        long_name: 'Czech Koruna',
        label: 'CZK',
        icon: 'i-mdi:currency-czk',
        sign: 'Kč'
    },
    {
        name: 'dkk',
        long_name: 'Danish Krone',
        label: 'DKK',
        icon: 'i-mdi:currency-dkk',
        sign: 'kr'
    },
    {
        name: 'hkd',
        long_name: 'Hong Kong Dollar',
        label: 'HKD',
        icon: 'i-mdi:currency-hkd',
        sign: 'HK$'
    },
    {
        name: 'hrk',
        long_name: 'Croatian Kuna',
        label: 'HRK',
        icon: 'i-mdi:currency-hrk',
        sign: 'kn'
    },
    {
        name: 'huf',
        long_name: 'Hungarian Forint',
        label: 'HUF',
        icon: 'i-mdi:currency-huf',
        sign: 'Ft'
    },
    {
        name: 'idr',
        long_name: 'Indonesian Rupiah',
        label: 'IDR',
        icon: 'i-mdi:currency-idr',
        sign: 'Rp'
    },
    {
        name: 'ils',
        long_name: 'Israeli New Shekel',
        label: 'ILS',
        icon: 'i-mdi:currency-ils',
        sign: '₪'
    },
    {
        name: 'isk',
        long_name: 'Icelandic Króna',
        label: 'ISK',
        icon: 'i-mdi:currency-isk',
        sign: 'kr'
    },
    {
        name: 'mxn',
        long_name: 'Mexican Peso',
        label: 'MXN',
        icon: 'i-mdi:currency-mxn',
        sign: '$'
    },
    {
        name: 'myr',
        long_name: 'Malaysian Ringgit',
        label: 'MYR',
        icon: 'i-mdi:currency-myr',
        sign: 'RM'
    },
    {
        name: 'nok',
        long_name: 'Norwegian Krone',
        label: 'NOK',
        icon: 'i-mdi:currency-nok',
        sign: 'kr'
    },
    {
        name: 'nzd',
        long_name: 'New Zealand Dollar',
        label: 'NZD',
        icon: 'i-mdi:currency-nzd',
        sign: 'NZ$'
    },
    {
        name: 'php',
        long_name: 'Philippine Peso',
        label: 'PHP',
        icon: 'i-mdi:currency-php',
        sign: '₱'
    },
    {
        name: 'pln',
        long_name: 'Polish Złoty',
        label: 'PLN',
        icon: 'i-mdi:currency-pln',
        sign: 'zł'
    },
    {
        name: 'ron',
        long_name: 'Romanian Leu',
        label: 'RON',
        icon: 'i-mdi:currency-ron',
        sign: 'lei'
    },
    {
        name: 'sek',
        long_name: 'Swedish Krona',
        label: 'SEK',
        icon: 'i-mdi:currency-sek',
        sign: 'kr'
    },
    {
        name: 'sgd',
        long_name: 'Singapore Dollar',
        label: 'SGD',
        icon: 'i-mdi:currency-sgd',
        sign: 'S$'
    },
    {
        name: 'thb',
        long_name: 'Thai Baht',
        label: 'THB',
        icon: 'i-mdi:currency-thb',
        sign: '฿'
    },
    {
        name: 'zar',
        long_name: 'South African Rand',
        label: 'ZAR',
        icon: 'i-mdi:currency-zar',
        sign: 'R'
    },
];
export const cryptoCurrencies:Array<ConverterCurrencyItem>  = [

    // Stable Coins
    {
        name: 'usdt',
        long_name: 'Tether',
        label: 'USDT',
        icon: 'i-c:usdt',
        sign: 'USDT'
    },
    {
        name: 'usdc',
        long_name: 'USD Coin',
        label: 'USDC',
        icon: 'i-c:usdc',
        sign: 'USDC',
    },
    {
        name: 'dai',
        long_name: 'Dai',
        label: 'DAI',
        icon: 'i-c:dai',
        sign: 'DAI'
    },
    {
        name: 'busd',
        long_name: 'Binance USD',
        label: 'BUSD',
        icon: 'i-c:busd',
        sign: 'BUSD'
    },
    {
        name: 'tusd',
        long_name: 'TrueUSD',
        label: 'TUSD',
        icon: 'i-c:tusd',
        sign: 'TUSD'
    },
    {
        name: 'usdp',
        long_name: 'Pax Dollar',
        label: 'USDP',
        icon: 'i-c:usdp',
        sign: 'USDP'
    },

    // cryptos
    {
        name: 'btc',
        long_name: 'Bitcoin',
        label: 'BTC',
        icon: 'i-c:btc',
        sign: '₿'
    },
    {
        name: 'eth',
        long_name: 'Ethereum',
        label: 'ETH',
        icon: 'i-c:eth',
        sign: 'Ξ'
    },
    {
        name: 'bnb',
        long_name: 'Binance Coin',
        label: 'BNB',
        icon: 'i-c:bnb',
        sign: 'BNB'
    },
    {
        name: 'ada',
        long_name: 'Cardano',
        label: 'ADA',
        icon: 'i-c:ada',
        sign: 'ADA'
    },
    {
        name: 'xrp',
        long_name: 'XRP',
        label: 'XRP',
        icon: 'i-c:xrp',
        sign: 'XRP'
    },
    {
        name: 'sol',
        long_name: 'Solana',
        label: 'SOL',
        icon: 'i-c:sol',
        sign: 'SOL'
    },
    {
        name: 'doge',
        long_name: 'Dogecoin',
        label: 'DOGE',
        icon: 'i-c:doge',
        sign: 'Ð'
    },
];

export const getSignFromQuote = (quote: string) => {
    return [
        ...converterCurrencies,
        ...cryptoCurrencies
    ].find(c => c.label?.toUpperCase() === quote?.toUpperCase())?.sign
}

export const defaultLang = 'en';

export const availableLanguages = {
    en: {
        label: 'English',
        icon: '🇺🇸',
        code: 'en'
    },
    ru: {
        label: 'Русский',
        icon: '🇷🇺',
        code: 'ru'
    },
    it: {
        label: 'Italiano',
        icon: '🇮🇹',
        code: 'it'
    },
    es: {
      label: 'Español',
      icon: '🇪🇸',
      code: 'es'
    },
    ko: {
        label: '한국어',
        icon: '🇰🇷',
        code: 'ko'
    },
    de: {
        label: 'Deutsch',
        icon: '🇩🇪',
        code: 'de'
    },
    fr: {
        label: 'Français',
        icon: '🇫🇷',
        code: 'fr'
    },
    tr: {
        label: 'Türkçe',
        icon: '🇹🇷',
        code: 'tr'
    },
    nl: {
        label: 'Nederlands',
        icon: '🇳🇱',
        code: 'nl'
    },
    zh: {
        label: '中文',
        icon: '🇨🇳',
        code: 'zh'
    },
    pt: {
        label: 'Português',
        icon: '🇵🇹',
        code: 'pt'
    },
    fil: {
        label: 'Filipino',
        icon: '🇵🇭',
        code: 'fil'
    }
};

export const MAX_TRANSLATION_BLOGS_PER_PIPELINE = 500;

export const GTM_ID = "G-XKD7Q41NP6"
export const REWARDFUL_ID = "a9ee4b"
export const FACEBOOK_ID = "376801938528025"
export const MICROSOFT_CLARITY_ID = "ncxh2lfgzk"

export const stripe = {
    STRIPE_SUBSCRIPTION_LINK_BASIC: "https://buy.stripe.com/6oE6qmfyU16n4PCaEE",
    STRIPE_SUBSCRIPTION_LINK_PRO: "https://buy.stripe.com/00g5mi4Ug2ar4PC001",
    STRIPE_SUBSCRIPTION_LINK_WHALE: 'https://buy.stripe.com/dR64ieeuQg1hdm87sD',
    STRIPE_SUBSCRIPTION_LINK_BASIC_YEARLY: "https://buy.stripe.com/5kA3ea72og1hfugcMO",
    STRIPE_SUBSCRIPTION_LINK_PRO_YEARLY: "https://buy.stripe.com/4gw8yugCY3evbe08x5",
    STRIPE_SUBSCRIPTION_LINK_WHALE_YEARLY: 'https://buy.stripe.com/4gw01Y3Qc3ev5TG00c',
}

export const supportedLanguages = Object.keys(availableLanguages);
export const supportedQuoteCurrencies = converterCurrencies.map(c => c.label);
export const supportedCryptoQuoteCurrencies = cryptoCurrencies.map(c => c.label);
export const allQuoteCurrencies = [
    ...supportedQuoteCurrencies,
    ...supportedCryptoQuoteCurrencies
];
export const MAX_ROUTE_URLS_PER_SITEMAP_FILE = 10_000;

